import src from "IMAGE";
export default { src, width: 1610, height: 237, blurWidth: 0, blurHeight: 0};
